import { render, staticRenderFns } from "./ui-dotlottie-loader.vue?vue&type=template&id=07b93588"
import script from "./ui-dotlottie-loader.vue?vue&type=script&lang=js"
export * from "./ui-dotlottie-loader.vue?vue&type=script&lang=js"
import style0 from "./ui-dotlottie-loader.vue?vue&type=style&index=0&id=07b93588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports